"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = createTextResolver;
const ApiHelper_1 = require("@aurora/shared-client/helpers/ApiHelper");
const assets_1 = require("@aurora/shared-types/assets");
const enums_1 = require("@aurora/shared-types/overrides/enums");
const log_1 = require("@aurora/shared-utils/log");
const log = (0, log_1.getLog)(module);
function createTextResolver(appType, aliasResolver = alias => alias, namespaceResolver = namespace => namespace) {
    function getText(locale, namespaces, client, tenant, lastModified) {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof window === 'undefined') {
                // eslint-disable-next-line prefer-destructuring
                const assetCaches = global.assetCaches;
                const cachedText = yield assetCaches.textCache.findTextBundles(() => Promise.resolve(client), tenant, locale, aliasResolver, namespaceResolver, namespaces, false, lastModified);
                return cachedText === null || cachedText === void 0 ? void 0 : cachedText.texts;
            }
            else {
                return (0, ApiHelper_1.getCachedAssetFromApi)(enums_1.CachedAssetType.TEXT, [locale, namespaces.join(',')], appType, lastModified);
            }
        });
    }
    return function textResolver(_1, _a, _b) {
        return __awaiter(this, arguments, void 0, function* (_, { locale, namespaces, lastModified = assets_1.LastModifiedKeys.DEFAULTS_ONLY }, { client, tenant }) {
            const now = performance.now();
            const { id: tenantId } = tenant;
            log.trace('Resolving texts for namespaces: %O, locale: %s and tenant %s', namespaces, locale, tenantId);
            const texts = yield getText(locale, namespaces, client, tenant, lastModified);
            log.trace('Texts resolved for namespaces: %O, locale: %s and tenant %s in %dms', namespaces, locale, tenantId, performance.now() - now);
            return texts;
        });
    };
}
//# sourceMappingURL=textResolver.js.map